import { faCar } from '@fortawesome/pro-regular-svg-icons';
import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { Quotation } from 'data-layer-cr/dist/models';
import { colors, moneyFormat } from 'design-system';
import InformationCardLayout from './InformationCardLayout';
import InformationRow from './InformationRow';

const { formatMoney } = moneyFormat;

const useStyle = makeStyles(() => ({
  subtitleContainer: {
    textTransform: 'capitalize',
    marginTop: 20,
  },
  descriptionText: {
    fontWeight: 900,
    fontSize: 17,
  },
  valueText: {
    fontWeight: 900,
    fontSize: 19,
  },
}));

type Props = {
  quotation: Quotation;
};

const VehicleInformationCard = ({ quotation }: Props): JSX.Element => {
  const classes = useStyle();
  const {
    summary: { carBrand, carModel, carYear, insuranceValue },
  } = quotation;
  const currency = quotation.quotationProfile.typeOfMoney;
  const carName = `${carBrand} ${carModel}`.toLowerCase();
  return (
    <InformationCardLayout
      icon={faCar}
      title="Datos del auto"
      data-testid="vehicle-information-card"
    >
      <Grid item xs={12}>
        <Typography
          data-testid="vehicle-text"
          variant="subtitle1"
          className={clsx(classes.subtitleContainer)}
          style={{ fontSize: 15, fontWeight: 400, color: colors.abbey }}
        >
          {carName}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Box mb={3}>
          <InformationRow
            data-testid="year-row"
            description="Año"
            value={carYear}
          />
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        container
        alignItems="baseline"
        justifyContent="space-between"
      >
        <Box>
          <Typography className={classes.descriptionText}>
            Suma asegurada
          </Typography>
        </Box>
        <Box>
          <Typography
            data-testid="ensurace-sum-text"
            className={classes.valueText}
          >
            {formatMoney(insuranceValue, false, currency)}
          </Typography>
        </Box>
      </Grid>
    </InformationCardLayout>
  );
};

export default VehicleInformationCard;
